import { Category } from '../reducers/products/categories'
import { getCategoriesDictionary, getConfigParam } from '../reducers/getters'

interface ReferenceGenerationParams {
    CategoryId: number
}

const referenceGeneration = (params: ReferenceGenerationParams): {reference: string, CategoryId: number} => {
    const CategoryId = params.CategoryId
    const formula = getConfigParam('referenceGeneration') || ''
    let result = formula
    let categoryCounterId = CategoryId
    if (formula.includes('{cat_ref}')) {
        const method = getConfigParam('typeCategoryReferenceGeneration')
        const categories = getCategoriesDictionary()
        if (!Object.keys(categories).length) {
            return { reference: '', CategoryId: categoryCounterId }
        }
        let catResult = categories[CategoryId].ref_code || ''
        let counterResult = ''
        if (method === 'heredate') {
            const recursive = recursiveRefCategoryUp(CategoryId, categories)
            const ref_code = recursive.ref_code
            categoryCounterId = recursive.CategoryId
            catResult = ref_code.join('')
        }
        if (formula.includes('{counter}')) {
            if (categories[categoryCounterId] && CategoryId !== 1) {
                counterResult = String(categories[categoryCounterId].counter + 1)
            }
        }
        result = result.replace('{cat_ref}', catResult).replace('{counter}', counterResult)
    }
    return { reference: result, CategoryId: categoryCounterId }
}

const recursiveRefCategoryUp = (CategoryId: number, categories: { [key: string]: Category }): { ref_code: string[], CategoryId: number } => {
    const category = categories[CategoryId]
    if (category.CategoryId) {
        const myRecursive = recursiveRefCategoryUp(category.CategoryId, categories)
        let myCategoryId = myRecursive.CategoryId
        if (category.ref_code) {
            myCategoryId = category.id
        }
        return { ref_code: [...myRecursive.ref_code, category.ref_code || ''], CategoryId: myCategoryId }
    }
    return { ref_code: [category.ref_code || ''], CategoryId: category.id}
}

export const recursiveRefCodeCategory = (CategoryId: number, categories: { [key: string]: Category }): number => {
    if (CategoryId) {
        const category = categories[CategoryId]
        if (category.CategoryId && !category.ref_code) {
            return recursiveRefCodeCategory(category.CategoryId, categories)
        }
    }
    return CategoryId
}

export const generateReferenceWithCheck = (params: ReferenceGenerationParams, reference?: string): { reference: string, CategoryId?: number } => {
    const formula = getConfigParam('referenceGeneration') || ''
    if ((formula.includes('{cat_ref}') || formula.includes('{counter}')) || (!reference || reference === '')) {
        return referenceGeneration(params)
    }
    return { reference }
}

export default referenceGeneration